<template>
<v-row class="mb-2">
  <v-col>
    <v-hover v-slot="{ hover }" open-delay="200">
      <v-card :color="dColor" :elevation="hover ? 16 : 2">
        <v-row>
          <v-col cols="12" sm="12">
            <v-list-item three-line>
              <v-list-item-content>
                <div class="mb-4">
                  <v-btn fab :color="lColor" elevation="0">
                    <v-icon color="white">{{mdi}}</v-icon>
                  </v-btn>
                  <span class="white--text mr-3 myTitle">{{title}}</span>
                </div>
                <div v-if="!show">
                  <v-list-item-title class="mt-3 white--text myPrice">
                    <span>*************</span>
                  </v-list-item-title>
                </div>
                <div v-else>
                  <div v-if="data">
                    <v-list-item-title class="mt-2 white--text myValue">
                      <span v-if="data.sum_value">{{Math.abs(data.sum_value) | valueDisplay}} گرم</span>
                      <span v-if="!data.sum_value">-</span>
                    </v-list-item-title>
                    <v-list-item-subtitle class="white--text myPrice">
                      <span v-if="data.sum_multiply">{{Math.abs(data.sum_multiply) | currencyDisplay }} ریال</span>
                      <span v-if="!data.sum_multiply && !data.sum">-</span>
                    </v-list-item-subtitle>
                    <v-list-item-title class="white--text myPrice">
                      <span v-if="data.sum">{{Math.abs(data.sum) | currencyDisplay}} ریال</span>
                      <span v-if="!data.sum && !data.sum_value">-</span>
                    </v-list-item-title>
                    <v-list-item-subtitle class="mb-2 white--text myAvg">
                      <span v-if="data.avg_price">{{(data.avg_price) | currencyDisplay }} ریال</span>
                      <span v-if="!data.avg_price">-</span>
                    </v-list-item-subtitle>
                    <v-list-item-subtitle class="white--text myCount">
                      <span v-if="data.count">{{data.count | currencyDisplay}} سند</span>
                    </v-list-item-subtitle>
                  </div>
                </div>
              </v-list-item-content>
            </v-list-item>
          </v-col>
          <!-- <v-col cols="12" sm="4"> -->
          <!-- <v-avatar size="100" class="mr-n6 mt-6" tile>
            <v-img src="../../assets/invoice.png" />
          </v-avatar> -->
          <!-- </v-col> -->
        </v-row>
      </v-card>
    </v-hover>
  </v-col>
</v-row>
</template>

<script>
export default {
  name: 'MyTicket',
  props: ['title', 'dColor', 'lColor', 'mdi', 'data', 'show'],
  // data: () => ({}),
}
</script>

<style lang="css" scoped>
.myTitle {
  font-size: 30px;
}
.myValue {
  font-size: 25px;
}
.myPrice {
  font-size: 25px;
}
.myAvg {
  font-size: 20px;
}
.myCount {
  font-size: 20px;
}
</style>
